import { render, staticRenderFns } from "./employee-details.vue?vue&type=template&id=251ff554"
import script from "./employee-details.vue?vue&type=script&lang=js"
export * from "./employee-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports